var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitlabIconRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338 311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M337.17 177.83l-18.91-58.12L280.84 4.43a6.47 6.47 0 0 0-12.27 0l-37.42 115.21H106.82L69.4 4.43a6.46 6.46 0 0 0-12.26 0L19.78 119.64.87 177.83c-1.72 5.3.16 11.1 4.66 14.39L169 311l163.44-118.78a12.9 12.9 0 0 0 4.73-14.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M169 310.91l62.16-191.28H106.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M169 310.91l-62.18-191.28h-87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M19.75 119.69L.84 177.81c-1.72 5.3.16 11.1 4.66 14.39L169 311 19.75 119.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M19.78 119.69h87.11L69.4 4.49a6.47 6.47 0 0 0-12.27 0l-37.35 115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M169 310.91l62.16-191.28h87.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M318.24 119.69l18.91 58.12a12.85 12.85 0 0 1-4.66 14.39L169 310.91l149.2-191.22h.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M318.28 119.69h-87.1L268.6 4.49a6.46 6.46 0 0 1 12.26 0l37.42 115.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabIconRgb);
export default __webpack_public_path__ + "static/media/gitlab-icon-rgb.0f56208bdb84c51b7f0a85efea9ecf4a.svg";
export { ForwardRef as ReactComponent };